import { motion } from "framer-motion";
import { Download } from "lucide-react";
import Generator from "./Generator";

const reveal = {
  initial: { y: 36, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, amount: 0.15 },
};

const MEMES = [
  {
    src: "/meme_sunglasses.png",
    caption: "Me, joining the pod early",
    rotate: "-rotate-2",
  },
  {
    src: "/meme_chill.png",
    caption: "No roadmap. Just waves.",
    rotate: "rotate-1",
  },
  {
    src: "/meme_hearteyes.png",
    caption: "When the pod gets louder",
    rotate: "rotate-2",
  },
  {
    src: "/meme_noise.png",
    caption: "Making some noise on Solana",
    rotate: "-rotate-1",
  },
];

export default function MemeWall() {
  return (
    <section
      id="memes"
      data-testid="meme-wall-section"
      className="relative bg-ocean-bg2 py-24 sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div {...reveal} className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-extrabold uppercase tracking-[0.3em] text-ocean-cyan">
            Meme Wall
          </p>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight sm:text-5xl">
            Memes from the deep.
          </h2>
          <p className="mt-3 text-base font-medium text-ocean-muted sm:text-lg">
            Right-click any meme to save it and flood the group chat.
          </p>
        </motion.div>

        <Generator />

        <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {MEMES.map((m, i) => (
            <motion.figure
              key={m.caption}
              data-testid={`meme-card-${i}`}
              {...reveal}
              transition={{ ...reveal, delay: i * 0.1 }}
              className={`sticker ${m.rotate} rounded-3xl bg-white p-3 transition-transform duration-300 hover:rotate-0 hover:-translate-y-2`}
            >
              <img
                src={m.src}
                alt={m.caption}
                className="aspect-square w-full rounded-2xl border-[3px] border-ocean-navy/10 object-cover"
                draggable="false"
              />
              <figcaption className="flex items-center justify-between gap-2 px-2 py-3">
                <span className="font-display text-base font-semibold leading-tight">
                  {m.caption}
                </span>
                <Download className="h-4 w-4 shrink-0 text-ocean-muted" />
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
